import { Text, FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Price = styled.span`
  ${({ theme: { components } }) => components.plans.fds_c_price_typo_S_extended};
`;

export const Devolution = styled.span`
  ${({ theme: { components } }) => components.plans.fds_c_price_typo_S};
`;

export const DiscountPrice = styled(Text)`
  text-decoration: line-through;
`;

export const PriceContainer = styled(FlexContainer)`
  position: relative;
`;

export const DiscountText = styled(Text)`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;
